(function () {
  var preloader = document.querySelector('[data-page-preloader]');
  if (!preloader) return;

  // El preloader arranca oculto (ver snippets/page-preloader.liquid) y solo se muestra
  // como transición al hacer clic en un enlace interno.
  var SAFETY_TIMEOUT_MS = 4000;
  var safetyTimer = null;

  function hidePreloader() {
    window.clearTimeout(safetyTimer);
    preloader.classList.add('is-hidden');
  }

  function showPreloader() {
    preloader.classList.remove('is-hidden');
    // Si la navegación no ocurre (descarga, usuario detiene la carga), no dejar la página tapada
    window.clearTimeout(safetyTimer);
    safetyTimer = window.setTimeout(hidePreloader, SAFETY_TIMEOUT_MS);
  }

  // Al volver con el botón Atrás (bfcache) la página se restaura tal cual: ocultarlo
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) hidePreloader();
  });

  function isInternalNavigationLink(link) {
    if (!link || !link.href) return false;
    if (link.target && link.target !== '_self') return false;
    if (link.hasAttribute('download')) return false;
    if (link.origin !== window.location.origin) return false;

    var href = link.getAttribute('href') || '';
    if (href.charAt(0) === '#') return false;
    if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return false;
    if (link.pathname === window.location.pathname && link.hash) return false;

    return true;
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest('a[href]');
    if (!isInternalNavigationLink(link)) return;

    showPreloader();
  });
})();
